import { render } from "./IconForceDelete.vue?vue&type=template&id=017ccc5f"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconForceDelete.vue"]])

export default __exports__